import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { IUserProfileClaim } from '@gik/calendar/models/Claim';

interface GiftCardClaimSectionProps {
  claimedItem: IUserProfileClaim;
}

const blockName = 'gift-card-claim-section';

export default function GiftCardClaimSection({ claimedItem }: GiftCardClaimSectionProps): React.ReactElement {
  const bem = bemBlock(blockName);

  if (!(claimedItem?.cartItems?.length > 0)) return null;

  const productName = claimedItem.cartItems[0].productName;
  const price = claimedItem.cartItems[0].price;
  const hasThumbnail = !!claimedItem.cartItems[0].thumbnailUrl;

  return (
    <div className={bem()}>
      {hasThumbnail && <img className={bem('image')} src={claimedItem.cartItems[0].thumbnailUrl} />}
      <p>
        You purchased a ${price} {productName} for {claimedItem.recipientFullName}.
      </p>
    </div>
  );
}
